import { render } from "./ThemedActionButton.vue?vue&type=template&id=4e9f0bfe"
import script from "./ThemedActionButton.vue?vue&type=script&lang=js"
export * from "./ThemedActionButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__